import styled from 'styled-components';

export const PostCard = styled.div`
	background: white;
	border-radius: 6px;
	overflow: hidden;
	box-shadow: 0 2px 8px rgba(52, 152, 219, 0.1);
	cursor: pointer;
	transition: all 0.2s ease;

	display: flex;
	flex-direction: column;
	gap: 0;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(52, 152, 219, 0.2);
	}
`;

export const PostImage = styled.img`
	width: 100%;
	height: 200px;
	object-fit: cover;
`;

export const PostContent = styled.div<{ $color: string }>`
	padding: 20px;
	border-top: 3px solid ${({ $color }) => $color};
`;

export const PostTitle = styled.h3`
	margin: 0 0 16px 0;
	font-size: 1.2em;
	color: #2c3e50;
	font-weight: 500;
`;

export const PostInfo = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const PostUnitat = styled.span<{ $color: string }>`
	color: ${({ $color }) => $color};
	font-size: 0.9em;
	font-weight: 500;
`;

export const PostDate = styled.span`
	color: #666;
	font-size: 0.9em;
`;
